<div class="download-links">
  <app-logo class="download-links__logo" [mode]="'logo'" [width]="60" [height]="60"></app-logo>

  <div class="download-links__subtitle">
    {{ 'components.downloadLinks.labels.subtitle' | translate }}
  </div>

  <a tuiButton class="download-links__button" appearance="outline" size="m" target="_blank" [href]="getDownloadLink()">
    {{ env.isWebAndroid ? ('components.downloadLinks.buttons.downloadInGooglePlay' | translate) : '' }}
    {{ env.isWebIos ? ('components.downloadLinks.buttons.downloadInAppStore' | translate) : '' }}
  </a>
</div>
